export default (container) => ({
  widgetOpen: false,
  widgetId: undefined || process.env.WIDGET_ID,
  openView: 'new_user_conversation',
  iFrameContainer: container,
  windowHandler: container.contentWindow,
  embedded: false,
  widgetFullWindow: false,
});
